import { stringToNumberArray } from "../shared/criteria-url-helpers";
import { LocationSearchCriteria } from "./types";

export type LocationCriteriaURLParams = {
  s?: string; //sort
  sd?: string; //sort dir
  //add your filters here, obfuscated for url
  geoMt?: number; // LocationTypeahead - matchType
  geoMi?: number; // LocationTypeahead - matchId
  specId?: string; // GroupeDeFonction - specialtyId
};

export const urlStateToCriteria =
  (companyKey: string) =>
  (
    key: keyof LocationCriteriaURLParams,
    value: string,
    criteria: LocationSearchCriteria
  ) => {
    // const updatedCriteria = structuredClone(criteria);
    const updatedCriteria: LocationSearchCriteria = JSON.parse(
      JSON.stringify(criteria)
    );
    switch (key) {
      case "s": //These keys here must match above
        updatedCriteria.sort = value ? Number(value) : undefined;
        break;
      case "sd":
        updatedCriteria.sortDirection = value ? Number(value) : undefined;
        break;
      case "geoMt": //location typeahead - mt
        if (updatedCriteria?.locationCriteria) {
          if (updatedCriteria?.locationCriteria?.location) {
            if (updatedCriteria?.locationCriteria?.location?.geography) {
              updatedCriteria.locationCriteria.location.geography.type = value
                ? parseInt(value)
                : undefined;
            } else {
              updatedCriteria.locationCriteria.location.geography = {
                ...criteria?.locationCriteria?.location,
                type: value ? parseInt(value) : undefined,
              };
            }
          } else {
            updatedCriteria.locationCriteria = {
              ...criteria?.locationCriteria,
              location: {
                geography: {
                  type: value ? parseInt(value) : undefined,
                },
              },
            };
          }
        } else {
          updatedCriteria.locationCriteria = {
            location: {
              geography: {
                type: value ? parseInt(value) : undefined,
              },
            },
          };
        }
        break;
      case "geoMi": //location typeahead - mi
        if (updatedCriteria?.locationCriteria) {
          if (updatedCriteria?.locationCriteria?.location) {
            if (updatedCriteria?.locationCriteria?.location?.geography) {
              updatedCriteria.locationCriteria.location.geography.id = value
                ? parseInt(value)
                : undefined;
            } else {
              updatedCriteria.locationCriteria.location.geography = {
                ...criteria?.locationCriteria?.location,
                id: value ? parseInt(value) : undefined,
              };
            }
          } else {
            updatedCriteria.locationCriteria = {
              ...criteria?.locationCriteria,
              location: {
                geography: {
                  id: value ? parseInt(value) : undefined,
                },
              },
            };
          }
        } else {
          updatedCriteria.locationCriteria = {
            location: {
              geography: {
                id: value ? parseInt(value) : undefined,
              },
            },
          };
        }
        break;
      case "specId": //Specialty Filter
        if (updatedCriteria?.locationCriteria) {
          if (updatedCriteria?.locationCriteria?.location) {
            updatedCriteria.locationCriteria.location.specialtyIds = value
              ? stringToNumberArray(value)
              : undefined;
          } else {
            updatedCriteria.locationCriteria = {
              ...criteria?.locationCriteria,
              location: {
                specialtyIds: value ? stringToNumberArray(value) : undefined,
              },
            };
          }
        } else {
          updatedCriteria.locationCriteria = {
            location: {
              specialtyIds: value ? stringToNumberArray(value) : undefined,
            },
          };
        }
        break;
      // Dont do anything w page number - is not part of crit here, it is adjacent
    }

    const companyCriteria = {
      companyKey,
    };

    if (!updatedCriteria.locationCriteria) {
      updatedCriteria.locationCriteria = {
        company: companyCriteria,
      };
    } else if (!updatedCriteria.locationCriteria.company) {
      updatedCriteria.locationCriteria.company = companyCriteria;
    }

    return updatedCriteria;
  };

export const getCriteriaParams = (
  searchCriteria: LocationSearchCriteria | undefined
) => {
  const criteriaAsUrlParams: LocationCriteriaURLParams = {};

  //convert search-x criteria to url object
  //sort
  criteriaAsUrlParams.s = searchCriteria?.sort?.toString();
  //sort direction
  criteriaAsUrlParams.sd = searchCriteria?.sortDirection?.toString();
  //match Type
  criteriaAsUrlParams.geoMt =
    searchCriteria?.locationCriteria?.location?.geography?.type;
  //match id
  criteriaAsUrlParams.geoMi =
    searchCriteria?.locationCriteria?.location?.geography?.id;
  //specialty id
  criteriaAsUrlParams.specId =
    searchCriteria?.locationCriteria?.location?.specialtyIds?.toString();

  return criteriaAsUrlParams;
};
